export const FIELDS_NAME_MAP_FOR_EVENT = {
  addresses: 'address',
  description: 'description',
  erpId: 'erp_id',
  name: 'name',
  taxId: 'tax_id',
  trade: 'trade',
  websiteUrl: 'website',
};
